import { render } from "./vButton.vue?vue&type=template&id=73baed1e&scoped=true"
import script from "./vButton.vue?vue&type=script&lang=js"
export * from "./vButton.vue?vue&type=script&lang=js"

import "./vButton.vue?vue&type=style&index=0&id=73baed1e&scoped=true&lang=scss"

import exportComponent from "C:\\DevWeb\\verdon\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73baed1e"]])

export default __exports__